export default "__VITE_ASSET__Dz4Uv2O9__"